import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export const persistRasterRecord = (persistUri) => {
  if (!persistUri) return;
  const url = persistUri;
  return fetchdata(url, { method: 'PATCH' })
    .then((result) => result)
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
};
